export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10337.0f258d10.jpg";